import { render, staticRenderFns } from "./cookie-category-translations-tab.vue?vue&type=template&id=5ac55228"
import script from "./cookie-category-translations-tab.vue?vue&type=script&lang=js"
export * from "./cookie-category-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports